module.exports = __webpack_public_path__ + "img/edit-circle.8cddd6cc.svg";